import React from 'react';
import { LogOut } from 'lucide-react';

export function LogoutModal({
  open = false,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md px-4"
      style={{ background: 'rgba(0,0,0,0.85)' }}
    >
      <div className="relative w-full max-w-[360px] animate-in fade-in zoom-in duration-300">
        {/* Glow behind the card */}
        <div 
          className="absolute inset-0 opacity-10 blur-[60px] rounded-full" 
          style={{ transform: 'scale(1.2)' }}
        />

        <div
          className="relative rounded-2xl overflow-hidden text-white border border-[#FC4420]/30"
          style={{
            background: 'linear-gradient(180deg, #0B0F19 0%, #050508 100%)',
            boxShadow: '0 0 40px rgba(0,0,0,0.5)',
          }}
        >
          {/* Header Accent */}
          <div 
            className="absolute top-0 left-0 w-full h-[2px]"
            style={{ background: 'linear-gradient(90deg, transparent, #FC4420, transparent)' }}
          />

          <div className="p-8 flex flex-col items-center">
            {/* Warning Icon */}
            <div className="w-16 h-16 rounded-full bg-[#FC4420]/10 flex items-center justify-center border border-[#FC4420]/20 mb-6 relative">
               <div className="absolute inset-0 rounded-full bg-[#FC4420]/5 animate-ping opacity-20" />
               <LogOut size={32} className="text-[#FC4420]" />
            </div>

            {/* Title */}
            <h3 className="text-2xl font-bold text-center mb-2 tracking-tight">
              Confirm Logout
            </h3>

            {/* Subtitle */}
            <p className="text-white/50 text-center mb-8 text-sm leading-relaxed">
              Are you sure you want to end your session? You will need to login again to access your account.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col gap-3 w-full">
              <button
                type="button"
                className="h-12 w-full rounded-xl text-white font-bold text-base transition hover:brightness-110 active:scale-95 flex items-center justify-center gap-2"
                style={{
                  background: 'linear-gradient(180deg, #FC4420 0%, #D32F2F 100%)',
                  boxShadow: '0 4px 15px rgba(252, 68, 32, 0.4), inset 0 1px 0 rgba(255,255,255,0.2)',
                }}
                onClick={onConfirm}
              >
                Yes, Logout
              </button>
              
              <button
                type="button"
                className="h-12 w-full rounded-xl text-white/70 font-semibold text-base transition hover:bg-white/5 active:scale-95 border border-white/10"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
